var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningInfoIcon = function SvgWarningInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D68000",
    fillRule: "evenodd",
    d: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1.5-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9.25 10a.25.25 0 0 0-.25.25v1.25c0 .14.11.25.25.25h.65c.06 0 .1.04.1.1v2.3a.1.1 0 0 1-.1.1h-.65a.25.25 0 0 0-.25.25v1.25c0 .14.11.25.25.25h3.5c.14 0 .25-.11.25-.25V14.5a.25.25 0 0 0-.25-.25h-.65a.1.1 0 0 1-.1-.1v-3.9a.25.25 0 0 0-.25-.25z",
    clipRule: "evenodd"
  })));
};
export default SvgWarningInfoIcon;